import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import PropTypes from "prop-types";
import { IoIosLogOut } from "react-icons/io";
import Divider from '@mui/material/Divider';
import { MdPayments } from "react-icons/md";
import { SiAntdesign } from "react-icons/si";
import { RiListSettingsFill } from "react-icons/ri";
import {
  Box,
  Drawer,
  Hidden,
  List,
  ListSubheader,
  Button,
  Typography,
} from '@mui/material';
import { padding, styled, textAlign } from "@mui/system";
import { useHistory } from "react-router-dom";
import NavItem from "./NavItem";
import { FaUser } from "react-icons/fa";
import { FaCalendarDays } from "react-icons/fa6";
import { GoClockFill } from "react-icons/go";
import { BiSolidBox } from "react-icons/bi";
import { SiJusteat } from "react-icons/si";
import { LiaPollHSolid } from "react-icons/lia";
import { useDispatch, useSelector } from 'react-redux';
import { FetchApiSlice } from 'src/service/ThunkApiCall/FetchApiSlice';
import { selectProfile } from 'src/service/Fetures/ProfileSlice';
import {
  MdDashboard,
} from "react-icons/md";
import { AuthContext } from "src/context/Auth";
import LogoutModal from "src/component/LogoutModal";
const sections = [
  {
    items: [
      {
        title: "Dashboard",
        modules: "",
        icon: MdDashboard,
        href: "/dashboard",
      },
      {
        title: "All Employees",
        modules: "",
        icon: FaUser,
        href: "/employee",
      },
      {
        title: "Attendance",
        modules: "",
        icon: FaCalendarDays,
        href: "/attendance",
      },
      {
        title: "Break Time",
        modules: "",
        icon: GoClockFill,
        href: "/allemp_break",
      },

      {
        title: "Designation",
        modules: "",
        icon: SiAntdesign,
        href: "/designation",
      },
      {
        title: "Holidays",
        modules: "",
        icon: SiJusteat,
        href: "/holiday",
      },
      {
        title: "Leaves",
        modules: "",
        icon: BiSolidBox,
        href: "/leaves",
      },
      {
        title: "Payroll",
        modules: "",
        icon: MdPayments,
        href: "/payroll",
      },
      {
        title: "Policies",
        modules: "",
        icon: LiaPollHSolid,
        href: "/policies",
      },
      {
        title: "Login Activity",
        modules: "",
        icon: RiListSettingsFill,
        href: "/emp_login_activity",
      },
    ],
  },
];

// user
const sections1 = [
  {
    items: [
      {
        title: "Dashboard",
        modules: "",
        icon: MdDashboard,
        href: "/employee_dashboard",
      },
      {
        title: "Attendance",
        modules: "",
        icon: FaCalendarDays,
        href: "/employee_attendance",
      },
      {
        title: "Break Time",
        modules: "",
        icon: GoClockFill,
        href: "/breaktime",
      },
      {
        title: "Holiday",
        modules: "",
        icon: SiJusteat,
        href: "/holiday",
      },
      {
        title: "Leaves",
        modules: "",
        icon: BiSolidBox,
        href: "/employee_leaves",
      },
      {
        title: "Payroll",
        modules: "",
        icon: MdPayments,
        href: "/payroll",
      },

      {
        title: "Policies",
        modules: "",
        icon: LiaPollHSolid,
        href: "/policies",
      },
      {
        title: "Login Activity",
        modules: "",
        icon: RiListSettingsFill,
        href: "/login_activity",
      },

    ],
  },
];

function renderNavItems({ items, pathname, permission, userType, depth = 0 }) {
  return (
    <StyledDashboard>
      <List disablePadding>
        {items.reduce(
          (acc, item) =>
            reduceChildRoutes({
              acc,
              item,
              pathname,
              depth,
              permission,
              userType,
            }),
          []
        )}
      </List>
    </StyledDashboard>
  );
}

function reduceChildRoutes({
  acc,
  pathname,
  item,
  depth,
}) {
  const key = item.title + depth;

  if (item.items) {
    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean()}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
      />
    );
  }

  return acc;
}
const StyledDashboard = styled("Box")(({ theme }) => ({
  "& .mobileDrawer": {
    width: 256,
    background: "#fff !important",
  },
  "& .desktopDrawer": {
    width: 242,
    // top: 80,
    overflow: "hidden",
    borderRight: "1px solid #ff860d5c",
    height: "100%",
    background: "#fff",
    boxShadow: "rgb(90 114 123 / 11%) 0px 7px 30px 0px",
    backdropFilter: "blur(44px)",
  },

  "& .logo1": {
    width: "100%",
    maxWidth: "150px"
  },
  "& .logoutButton": {
    // position: "absolute",     
    // bottom: "5px",
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: "13px",
    marginTop: "24px",
    width: "calc(100% - 26px)",
    textAlign: "center",
    "& .MuiButton-label": {
      justifyContent: "center",
    },
  },
  "& .welcomecss": {
    "h6": {
      // textAlign: "center",
      paddingLeft: "35px"
    }
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const history = useHistory();
  const auth = useContext(AuthContext);
  const location = useLocation();
  const permission = auth.userData.permission;
  const [open5, setOpen5] = useState(false);
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const logoutHandler = () => {
    history.push("/");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("userType");
    window.localStorage.removeItem("userID");
    window.localStorage.removeItem("empdata");
    window.localStorage.removeItem("auth")

  };

  const USERTYPE = window.localStorage.getItem("userType");
  const dispatch = useDispatch();
  const { status, data, error } = useSelector(selectProfile);
  useEffect(() => {
    dispatch(FetchApiSlice());
  }, [dispatch]);

  const user_type = USERTYPE === "USER" ? sections1 : sections;
  const content = (
    <StyledDashboard>
      <Box height="100%" display="flex" flexDirection="column">
        <Box height="100%" display="flex" flexDirection="column">
          <Box height="100%" display="flex" flexDirection="column">
            <PerfectScrollbar options={{ suppressScrollX: true }}>
              <Box>
                <Box p={4}>
                  <img
                    src={"images/logow.png"}
                    alt="image"
                    className="logo1"
                    style={{ cursor: "pointer" }}
                  // onClick={() => history.push("/")}
                  />
                </Box>
                <Box className="welcomecss" >
                  <Typography variant="h6">Welcome {data && data?.firstName}</Typography>
                </Box>
                <Box pt={1} pb={3}>
                  <Divider style={{ borderColor: "#dbdbdb78" }} />
                </Box>
                <Box>
                  {user_type.map((section, j) => {
                    let item;
                    item = section.items;
                    return (
                      <List
                        key={`menu${j}`}
                        subheader={
                          <ListSubheader disableGutters disableSticky>
                            {section.subheader}
                          </ListSubheader>
                        }
                      >
                        {renderNavItems({
                          items: item,
                          pathname: location.pathname,
                          permission: permission,
                          userType: auth.userData.userType,
                        })}
                      </List>
                    );
                  })}
                </Box>
                <Box className="hoverText">
                  <Button
                    variant="containedOutline"
                    color="primary"
                    onClick={() => setOpen5(true)}
                    className="logoutButton"
                  >
                    &nbsp;Logout &nbsp; <IoIosLogOut style={{ fontSize: "20px" }} />
                  </Button>
                </Box>
              </Box>

            </PerfectScrollbar>
            {open5 && (
              <LogoutModal
                open5={open5}
                title="Are you sure want to logout ?"
                handleClose={() => setOpen5(false)}
                logoutHandler={logoutHandler}
              />
            )}
          </Box>
        </Box>
      </Box>
    </StyledDashboard>
  );

  return (
    <>
      <StyledDashboard>
        <Hidden lgUp>
          <Drawer
            anchor="left"
            classes="mobileDrawer"
            onClose={onMobileClose}
            open={openMobile}
            variant="temporary"
          >

            {content}
          </Drawer>
        </Hidden>
        <Hidden mdDown>
          <Drawer
            style={{ width: "42px" }}
            anchor="left"
            classes="desktopDrawer"
            open
            variant="persistent"
          >
            {content}
          </Drawer>
        </Hidden>
      </StyledDashboard>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
